import qs from 'qs'

export const getQueryParams = search =>
  qs.parse(search, { ignoreQueryPrefix: true })

// The trailing slash keeps /catering/orders/:token (catering-order-response) out.
export const isCateringOrderUrl = (url) =>
  String(url).indexOf('/catering/order/') === 0

export const isOrderUrl = (url) =>
  String(url).indexOf('/order') === 0 || isCateringOrderUrl(url)
export const isReviewUrl = (url,venueId) => String(url).indexOf(`/order/${venueId}/review`) === 0

export const isVenueUrl = url => String(url).indexOf('/restaurant') === 0
export const isLandingPage = url => String(url).indexOf('/landing-page') === 0
